export const sweetViolet = {
    sweetViolet100: '#faf9fc',
    sweetViolet200: '#f8f4fc',
    sweetViolet300: '#f3e9ff',
    sweetViolet400: '#eeddff',
    sweetViolet500: '#e6cfff',
    sweetViolet600: '#dcbdfc',
    sweetViolet700: '#cfa6f7',
    sweetViolet800: '#bf87f1',
    sweetViolet900: '#ba82ec',
    sweetViolet1000: '#ae76df',
    sweetViolet1100: '#7c44a9',
    sweetViolet1200: '#47126a',
    sweetVioletAccentContrast: '#ffffff',
    sweetVioletAccentSurface: '#f9f5fd',
};

export const sweetVioletAlpha = {
    sweetViolet100: 'rgba(125, 61, 252, 0.02)',
    sweetViolet200: 'rgba(139, 26, 252, 0.04)',
    sweetViolet300: '#f3e9ff',
    sweetViolet400: '#eeddff',
    sweetViolet500: '#e6cfff',
    sweetViolet600: 'rgba(125, 1, 252, 0.25)',
    sweetViolet700: 'rgba(122, 3, 238, 0.35)',
    sweetViolet800: 'rgba(122, 2, 229, 0.47)',
    sweetViolet900: 'rgba(117, 2, 220, 0.49)',
    sweetViolet1000: 'rgba(105, 0, 197, 0.53)',
    sweetViolet1100: 'rgba(78, 2, 139, 0.73)',
    sweetViolet1200: 'rgba(57, 0, 95, 0.93)',
    sweetVioletAccentContrast: '#ffffff',
    sweetVioletAccentSurface: 'rgba(248, 243, 253, 0.8)',
};

export const sweetVioletDark = {
    sweetViolet100: '#140e19',
    sweetViolet200: '#1c1424',
    sweetViolet300: '#2e1c3e',
    sweetViolet400: '#3c2152',
    sweetViolet500: '#472960',
    sweetViolet600: '#53336f',
    sweetViolet700: '#5f3d7e',
    sweetViolet800: '#6b478d',
    sweetViolet900: '#77519c',
    sweetViolet1000: '#835bab',
    sweetViolet1100: '#8f65ba',
    sweetViolet1200: '#9b6fc9',
    sweetVioletAccentContrast: '#ffffff',
    sweetVioletAccentSurface: '#1c1424',
};

export const sweetVioletDarkAlpha = {
    sweetViolet100: 'rgba(20, 14, 25, 0.01)',
    sweetViolet200: 'rgba(28, 20, 36, 0.04)',
    sweetViolet300: 'rgba(46, 28, 62, 0.11)',
    sweetViolet400: 'rgba(60, 33, 82, 0.18)',
    sweetViolet500: 'rgba(71, 41, 96, 0.24)',
    sweetViolet600: 'rgba(83, 51, 111, 0.31)',
    sweetViolet700: 'rgba(95, 61, 126, 0.38)',
    sweetViolet800: 'rgba(107, 71, 141, 0.45)',
    sweetViolet900: 'rgba(119, 81, 156, 0.7)',
    sweetViolet1000: 'rgba(131, 91, 171, 0.65)',
    sweetViolet1100: 'rgba(143, 101, 186, 0.83)',
    sweetViolet1200: 'rgba(155, 111, 201, 0.96)',
    sweetVioletAccentContrast: '#ffffff',
    sweetVioletAccentSurface: 'rgba(28, 20, 36, 0.5)',
};
